import { clsx } from '../../utils/cn.js';
import { BRAND_LEGAL_NAME, BRAND_SHORT_NAME } from '../../constants/brand.js';

/**
 * @param {'onDark' | 'onLight'} variant — fondo oscuro (footer) o claro (navbar)
 */
export default function BrandName({ variant = 'onLight', className, legalClassName, shortNameClassName }) {
  const onDark = variant === 'onDark';

  return (
    <div className={clsx('min-w-0 leading-tight', className)}>
      <span
        className={clsx(
          'block font-display font-semibold',
          onDark ? 'text-lg text-white' : 'truncate text-base text-black',
          shortNameClassName
        )}
      >
        {BRAND_SHORT_NAME}
      </span>
      <span
        className={clsx(
          'mt-1 block font-medium uppercase tracking-wide',
          onDark ? 'text-xs text-slate-400' : 'truncate text-[10px] tracking-wider text-neutral-800',
          legalClassName
        )}
      >
        {BRAND_LEGAL_NAME}
      </span>
    </div>
  );
}
